import axios from 'axios'
import { toast } from 'react-toastify'

const config = {
  baseURL: `${process.env.REACT_APP_THESEUS_URL}`,
  withCredentials: true,
}

console.log(process.env.REACT_APP_THESEUS_URL, 'THESEUS URL')

const theseus = axios.create(config)

theseus.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('theseus error', { error })
    if (error?.response?.status === 503) {
      toast.error(
        'Our servers are a little busy at the moment. Please try again in a few minutes.',
      )
    }

    // This `return error` does not fall in a catch block
    // We should return Promise.reject()
    // This means refactoring all the code using theseus.[method] and checking
    // if error handling works correctly
    return error

    // if (error.response) {
    //   return Promise.reject(error.response)
    // }
    // return Promise.reject(error.message)
  },
)

const theseus2 = axios.create(config)

theseus2.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('theseus 2 error', { error })
    if (error?.response?.status === 503) {
      toast.error(
        'Our servers are a little busy at the moment. Please try again in a few minutes.',
      )
    }
    if (error.response) {
      return Promise.reject(error.response)
    }
    return Promise.reject(error.message)
  },
)

export { theseus, theseus2 }
